import Color from 'color'
import { propSerializer } from 'ymodel'

propSerializer<Color, string>(Color, {
  deserialize: serialized => new Color(serialized),
  serialize:   color      => color.hex(),
})